import styled from 'styled-components';
const LayoutWrapper = styled.div`
    .ant-layout{
        min-height:100vh;
        // height:100vh;
        background:#fff;
    }
    .ant-layout-content{
        background:#fff;
    }

    .p-radiobutton .p-radiobutton-box {
        border: 1px solid var(--main-color);
        margin: auto;
        border-radius: 10px;
        opacity: 1;
        width: 15px;
        height: 15px;
    
        .p-radiobutton-icon {
        display: none;
        visibility: hidden;
        }
        &.p-highlight {
        border-color: var(--main-color);
        background: var(--main-color);
        }
    }
    .p-radiobutton .p-radiobutton-box.p-highlight:not(.p-disabled):hover {
        border-color: var(--main-color);
        background: var(--main-color);
    }
    .p-radiobutton .p-radiobutton-box:not(.p-disabled):not(.p-highlight):hover {
        border-color: var(--main-color);
    }


    .p-inputtext:enabled:focus:not(.p-invalid),.p-inputtext:enabled:hover:not(.p-invalid),.p-dropdown:not(.p-disabled):not(.p-invalid):hover{
        box-shadow: none;
        border-color:#286C4D
    }



    .p-column-header-content{
        font-size: 11px;
        justify-content: center;
    }

    // .p-datatable table *:not(.p-datatable-thead):not(.p-radiobutton *):not(.p-checkbox *) {
    //     border: none !important;
    // }

    .p-datatable-wrapper{
        border : 1px solid #4BB8A7;
        border-radius: 20px;
        padding: 0 20px;
    }

    .p-datatable-thead{
        border-bottom: 1px solid #4BB8A7 !important;
    }

    .p-datatable-thead th{
        background: white !important;
    }

    .p-datatable .delete-action{
        padding: 5px;
        background: var(--main-color);
        border-radius: 50%;
        width: 30px;
        height: 30px;
    }

    .p-datatable .delete-action svg{
        width: 13px;
    }

    .p-checkbox .p-checkbox-box{
        width: 18px;
        height: 18px;
        border: 1px solid var(--main-color);
    }
    .p-checkbox:not(.p-checkbox-disabled) .p-checkbox-box:hover{
        border: 1px solid var(--main-color);
    }
    .p-checkbox .p-checkbox-box .p-checkbox-icon{
        font-size: 11px;
        font-weight: bold;
    }
    .p-checkbox .p-checkbox-box.p-highlight{
        background-color: var(--main-color);
        border-color: var(--main-color);
    }
    .p-checkbox:not(.p-checkbox-disabled) .p-checkbox-box.p-highlight:hover{
        background-color: var(--main-color);
        border-color: var(--main-color); 
        opacity:0.8;
    }
    .p-toast{
      width:21rem;
    }

  

`;

export default LayoutWrapper;